import React from "react";
import logo from "../../static/images/Logo.png";
import Form from "../Form";
import Spinner from "../Spinner/Spinner";
import classes from "./LoadingScreen.module.scss";

const LoadingScreen = () => {
  return (
    <Form>
      <div className={classes.container}>
        <img src={logo} alt="Sapu Logo" className={classes.logo} />
        <Spinner />
      </div>
    </Form>
  );
};

export default LoadingScreen;
